import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import ZipingListComponent from '../components/ziping/zipingList.jsx';
import {closeZipingListModal, openStudentinfoModal} from "../redux/actions/modelsActive";
import {getZipingListRequest} from "../service/user";
import defaultImg from "../img/bee.png";
import {FILE_URL} from "../util/constants";
import PubSub from "pubsub-js";

class ZipingListContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'getZipingList',
            'chakanInfo',
            'handleImageErrored'
        ]);
        this.state = {
            studentList:[],
            zhibiaoList:[]
        }


    }

    componentDidMount() {

        this.getZipingList();
    }



    handleImageErrored(index){

        var list = this.state.studentList;
        list[index].img = defaultImg;

        this.setState({
            studentList:list,
        });
    }

    chakanInfo(pid,name,face_imgurl){
        sessionStorage.setItem('studentpid',pid)
        sessionStorage.setItem('studentname',name)

        sessionStorage.setItem('face_imgurl',face_imgurl)

        this.props.openStudentinfoModal();
    }

    getZipingList(){
        getZipingListRequest(sessionStorage.getItem('classcode'), (data) => {
            console.log(data)
            if(data.ret=='1'){
                // this.setState({
                //     studentList:data.data.xuesheng
                // });

                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].img = list[i].img==null||list[i].img==''?'':list[i].img
                }

                this.setState({
                    studentList:list,
                    zhibiaoList:data.data.zp_fenlei
                });
            }else{
                this.setState({
                    studentList:[]
                });
            }
        });
    }

    render() {

        return (
            <ZipingListComponent
                closeZipingListModal={this.props.closeZipingListModal}
                studentList={this.state.studentList}
                zhibiaoList={this.state.zhibiaoList}
                chakanInfo={this.chakanInfo}
                handleImageErrored={this.handleImageErrored}
            />
        )
    }


}

ZipingListContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeZipingListModal: () => dispatch(closeZipingListModal()),
        openStudentinfoModal:() => dispatch(openStudentinfoModal()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ZipingListContainer);
